import { useActiveCircle } from '@rhg/hooks/use-active-circle';
import { useMediaPackProgram } from '@rhg/hooks/use-media-pack-program';
import { useProgram } from '@rhg/hooks/use-program';
import { useProgramContext } from '@rhg/hooks/use-program-context';
import {
    ProgramContextState,
    ProgramContextProps,
} from '@rhg/hooks/use-program-context/types';
import { useWorkflowByDefnIdForRecipient } from '@rhg/hooks/use-workflows';
import { createContext, PropsWithChildren } from 'react';

export const ProgramContext = createContext<ProgramContextState>(undefined!);

export function ProgramProvider({
    program,
    packClass,
    workflow,
    packProgram,
    isFetched,
    children,
}: PropsWithChildren<ProgramContextProps>) {
    const state = useProgramContext({
        program,
        packClass,
        workflow,
        packProgram,
        isFetched,
    });
    return (
        <ProgramContext.Provider value={state}>
            {children}
        </ProgramContext.Provider>
    );
}

export function ActiveProgramProvider({
    program,
    packClass,
    workflow,
    children,
}: PropsWithChildren<ProgramContextProps>) {
    const { activeCircleId } = useActiveCircle();
    const { program: activeProgram, isFetched: isProgramFetched } = useProgram(
        program?.id,
        packClass,
        activeCircleId
    );
    const { workflow: activeWorkflow, isFetched: isWorkflowFetched } =
        useWorkflowByDefnIdForRecipient({
            workflowDefnId: workflow?.workflowDefn.defnId ?? '',
            circleId: activeCircleId,
        });

    const { packProgram, isFetched: isPackProgramFetched } =
        useMediaPackProgram({ packClass, programId: program?.id });

    return (
        <ProgramProvider
            program={activeProgram}
            workflow={activeWorkflow}
            packClass={packClass}
            packProgram={packProgram}
            isFetched={
                isWorkflowFetched && isProgramFetched && isPackProgramFetched
            }
        >
            {children}
        </ProgramProvider>
    );
}
